<template>
  <div id="app">
    <!-- 标题 -->
    <header class="header">💎 六小福珠宝</header>

    <!-- 新增：品牌说明 + 电话 -->

    <!-- 时间栏 -->
    <div class="time-bar">
      <span class="time-icon">⏰</span>
      <span class="time-text">{{ currentTime }}</span>
      <span class="status">开盘</span>
    </div>

    <!-- 表头 -->
    <div class="table-header">
      <div class="col">商品</div>
      <div class="col">回购</div>
      <div class="col">销售</div>
      <div class="col">高 / 低</div>
    </div>

    <!-- 行情数据 -->
    <div v-if="quotes.length > 0">
      <div v-for="quote in quotes" :key="quote.id" class="table-row">
        <div class="col name">{{ quote.name }}</div>
        <div class="col" :class="getChangeColor(quote, 'l')">
          {{ quote.l.toFixed(2) }}
        </div>
        <div class="col" :class="getChangeColor(quote, 'h')">
          {{ quote.h.toFixed(2) }}
        </div>
        <div class="col highlow">
          <div class="high red">{{ quote.zh.toFixed(2) }}</div>
          <div class="low green">{{ quote.zl.toFixed(2) }}</div>
        </div>
      </div>

      <!-- 新增：风险提示文字 -->
      <div class="quote-note">
        ⚠️ 行情数据来源于网络，仅供参考，不作为交易依据
      </div>
    </div>

    <div v-else class="loading">📡 数据加载中...</div>

    <!-- 分享按钮 -->
    <div class="share-btn">
      <button @click="sharePage">📤 分享给朋友</button>
    </div>

    <!-- 新增：底部联系信息 -->
    <footer class="footer">
      <div>六小福珠宝 · 欢迎免费加盟</div>
      <div>电话微信：19567933931</div>
      <div>座机：0311-83361616</div>
      <div>地址：辛集市建设大街85号</div>
    </footer>
  </div>
</template>


<script>
export default {
  name: "App",
  data() {
    return {
      currentTime: this.formatDate(new Date()),
      quotes: [],
      prevQuotes: [],
      gainData: [],
      timer: null,
      quoteTimer: null,
      insertTimer: null
    };
  },
  methods: {
    formatDate(date) {
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, "0");
      const d = String(date.getDate()).padStart(2, "0");
      const hh = String(date.getHours()).padStart(2, "0");
      const mm = String(date.getMinutes()).padStart(2, "0");
      const ss = String(date.getSeconds()).padStart(2, "0");
      return `${y}-${m}-${d} ${hh}:${mm}:${ss}`;
    },
    async fetchGainData() {
      try {
        const res = await fetch("https://admin.xj566.top/api/api.php");
        const json = await res.json();
        this.gainData = json.code === 200 ? json.data : [];
      } catch (e) {
        console.error("获取增益数据失败", e);
        this.gainData = [];
      }
    },
    async fetchQuote() {
      try {
        await this.fetchGainData();
        const res = await fetch("https://admin.xj566.top/api/apis.php");
        const json = await res.json();
        if (json.code === 200 && Array.isArray(json.data)) {
          const newQuotes = json.data.map(item => {
            const add = this.gainData.find(a => a.name === item.name) || { hig: 0, low: 0 };
            const h = parseFloat(item.h) + parseFloat(add.hig);
            const l = parseFloat(item.l) + parseFloat(add.low);
            return { id: item.id, name: item.name, h, l, zh: parseFloat(item.zh), zl: parseFloat(item.zl) };
          });
          this.prevQuotes = this.quotes;
          this.quotes = newQuotes;
        }
      } catch (e) {
        console.error("获取行情失败", e);
      }
    },
    getChangeColor(quote, key) {
      const prev = this.prevQuotes.find(q => q.id === quote.id);
      const lastColor = this.prevQuotesColor ? this.prevQuotesColor[quote.id]?.[key] : null;

      let color = lastColor || "red"; // 默认红色

      if (key === "h" && prev) {
        if (quote.h > prev.h) color = "red";
        else if (quote.h < prev.h) color = "green";
        // 相等时保持上次颜色
      } else if (key === "l" && prev) {
        if (quote.l > prev.l) color = "red";
        else if (quote.l < prev.l) color = "green";
      } else if (key === "zh") {
        color = "red";
      } else if (key === "zl") {
        color = "green";
      }

      // 保存颜色状态
      if (!this.prevQuotesColor) this.prevQuotesColor = {};
      if (!this.prevQuotesColor[quote.id]) this.prevQuotesColor[quote.id] = {};
      this.prevQuotesColor[quote.id][key] = color;

      return color;
    },

    sharePage() {
      const shareData = {
        title: "六小福珠宝实时行情",
        text: "实时更新的黄金珠宝价格，点击查看！",
        url: window.location.href
      };
      if (navigator.share) {
        navigator.share(shareData).catch(err => console.error("分享失败", err));
      } else {
        prompt("请复制以下链接分享：", window.location.href);
      }
    }
  },
  mounted() {
    this.timer = setInterval(() => {
      this.currentTime = this.formatDate(new Date());
    }, 1000);
    this.fetchQuote();
    this.quoteTimer = setInterval(this.fetchQuote, 3000);
  },
  beforeUnmount() {
    clearInterval(this.timer);
    clearInterval(this.quoteTimer);
    clearInterval(this.insertTimer);
  }
};
</script>

<style>
#app {
  background-color: #121212;
  min-height: 100vh;
  margin: 0;
  padding: 0;
  color: #fff;
  font-family: "Microsoft YaHei", sans-serif;
  text-align: center;
}

.header {
  font-size: 5vw;
  font-weight: bold;
  color: #f9c74f;
  padding: 2vh 0;
  text-shadow: 0 0 10px #f6b93b;
}

.time-bar {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #1e1f25;
  padding: 1vh;
  font-size: 2vw;
  border-bottom: 1px solid #333;
}
.time-icon {
  margin-right: 1vw;
}
.status {
  font-weight: bold;
  margin-left: 1vw;
  color: #f94144;
}

.table-header {
  display: flex;
  background: #222;
  margin-top: 1vh;
  border-radius: 5px 5px 0 0;
  overflow: hidden;
}
.table-header .col {
  flex: 1;
  padding: 1vh 0;
  border-right: 1px solid #333;
  font-size: 3.8vw;
  font-weight: bold;
  text-align: center;
}
.table-header .col:last-child {
  border-right: none;
}

.table-row {
  display: flex;
  background: #1c1d22;
  margin-bottom: 1vh;
  padding: 1vh 0;
  border-radius: 6px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.4);
}
.table-row .col {
  flex: 1;
  text-align: center;
  font-size: 3.8vw;
  display: flex;
  justify-content: center;
  align-items: center;
}
.name {
  color: #f9c74f;
}
.red {
  color: #ff4d4f;
  font-weight: bold;
}
.green {
  color: #4caf50;
  font-weight: bold;
}

/* 高低上下排列 */
.highlow {
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 1.4;
}
.highlow .high {
  margin-bottom: 0.5vh;
}

.loading {
  margin-top: 6vh;
  font-size: 4.5vw;
  color: #aaa;
}

.quote-note {
  margin-top: 1vh;
  font-size: 1vw;
  color: #b15408;
  font-weight: bold;
}

.share-btn {
  margin-top: 5vh;
}
.share-btn button {
  padding: 1.5vh 4vw;
  font-size: 1vw;
  color: #000;
  background: linear-gradient(135deg, #f9c74f, #f6b93b);
  border: none;
  border-radius: 10px;
  cursor: pointer;
  box-shadow: 0 4px 8px rgba(0,0,0,0.3);
}
.share-btn button:hover {
  background: linear-gradient(135deg, #ffd166, #f9c74f);
}
/* 品牌说明 */
.brand-info {
  margin-bottom: 1vh;
}
.brand-text {
  font-size: 2.5vw;
  color: #ccc;
}
.brand-phone {
  font-size: 2.8vw;
  margin-top: 0.5vh;
}
.brand-phone a {
  color: #f9c74f;
  text-decoration: none;
  font-weight: bold;
}

/* 底部信息 */
.footer {
  margin-top: 6vh;
  padding: 2vh 0;
  font-size: 1.8vw;
  color: #888;
  border-top: 1px solid #333;
}
.footer {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;

  background: rgba(18, 18, 18, 0.95);
  border-top: 1px solid #333;

  text-align: center;
  padding: 1.5vh 0;

  font-size: 1.8vw;
  color: #ccc;

  z-index: 9999;
}

</style>
